// import { ThemeProvider } from "@material-ui/styles";
import { useTheme } from "./ThemeProvider";
// import { createTheme, ThemeProvider } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useMemo, useState } from "react";

function DefaultThemeProvider({ children }) {
  const [ThemeMode, toggleTheme] = useTheme();

  const theme = useMemo(
    () =>
      createTheme({
        components: {
          MuiListItemButton: {
            defaultProps: {
              disableTouchRipple: true,
            },
          },
        },
        palette: {
          mode: ThemeMode,
          // primary: { main: ThemeMode == 'dark' ? "rgb(102, 157, 246)" : "rgb(102, 157, 246)" },
          secondary: { main: ThemeMode == "dark" ? "#747f8d" : "#36393f" },
          third: {
            main: ThemeMode == "dark" ? "#0B0B0E" : "#36393f",
            disabledTextColor: ThemeMode == "dark" ? "#626262" : "#CACACA",
            secondary: ThemeMode == "dark" ? "#202124" : "#F2F3F5",

          },
          background: { paper: ThemeMode == "dark" ? "#121217" : "#f2f3f5" },
        },
      }),
    [ThemeMode]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default DefaultThemeProvider;
